import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=44a44aea"
import script from "./Terms.vue?vue&type=script&setup=true&lang=ts"
export * from "./Terms.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Terms.vue?vue&type=style&index=0&id=44a44aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports